module.exports = __webpack_public_path__ + "static/media/log-out.115fa16e.svg";